import { SnippetView } from "../api-generated";
import clsx from "clsx";
import { getTokenString } from "../utils";
import InlineDef from "./InlineDef";

interface Props {
  snippet: SnippetView;
}

const InterestingWordInContext: React.FC<Props> = ({ snippet }) => {
  return (
    <p>
      {snippet.text.tokens.map((token, index) => {
        const isTarget = index === snippet.wordAndItsIndex?.second;
        const tokenString = getTokenString(token);
        return (
          <span key={index} className={clsx({ "bg-pink-300": isTarget })}>
            {
              //TODO: illegal state - snippet.word shouldn't be undefined
              isTarget && snippet.wordAndItsIndex ? (
                <span className="inline-flex flex-col items-center">
                  <span>{tokenString}</span>
                  <InlineDef
                    word={snippet.wordAndItsIndex.first}
                    location={snippet.sourceLocation}
                  />
                </span>
              ) : (
                <>{tokenString}</>
              )
            }
          </span>
        );
      })}
    </p>
  );
};

export default InterestingWordInContext;
